import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const SparkleIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" className={className} onClick={onClick}>
      <g clipPath="url(#clip0_4325_726)">
        <path d="M13.1667 6.00008L14 4.16675L15.8333 3.33341L14 2.50008L13.1667 0.666748L12.3333 2.50008L10.5 3.33341L12.3333 4.16675L13.1667 6.00008Z" fill="#0C0F24"/>
        <path d="M13.1667 10L12.3333 11.8333L10.5 12.6667L12.3333 13.5L13.1667 15.3333L14 13.5L15.8333 12.6667L14 11.8333L13.1667 10Z" fill="#0C0F24"/>
        <path d="M8.16699 6.33341L6.50033 2.66675L4.83366 6.33341L1.16699 8.00008L4.83366 9.66675L6.50033 13.3334L8.16699 9.66675L11.8337 8.00008L8.16699 6.33341ZM7.16033 8.66008L6.50033 10.1134L5.84033 8.66008L4.38699 8.00008L5.84033 7.34008L6.50033 5.88675L7.16033 7.34008L8.61366 8.00008L7.16033 8.66008Z" fill="#0C0F24"/>
      </g>
      <defs>
        <clipPath id="clip0_4325_726">
          <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default SparkleIcon;
